import { AbstractFilterModel } from "@gipi-pages/abstract/models/abstract-filter.model";
import { TypeAuthorities } from "@gipi-ui/enums/enum-authorities.enum";

export class UserFilterDTO extends AbstractFilterModel {

    roleDescriptionList: TypeAuthorities[];

}
